var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M0 0h24v22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 19.852l-5.6-2.632V2.148l5.6 2.632v15.07zM8.8 4.804l6.4-2.708v15.1l-6.4 2.71v-15.1zM1.6 2.148L7.2 4.78v15.07L1.6 17.22V2.148zm21.925 1.31l-7.2-3.385C16.317.07 16.308.07 16.3.065 16.266.05 16.23.04 16.196.032L16.1.01c-.037-.006-.074-.005-.11-.005-.027 0-.054-.003-.082.001-.037.004-.074.014-.1.025l-.08.023c-.008.003-.015.003-.023.006L8.016 3.313 1.125.073C.878-.044.59-.02.364.137A.86.86 0 0 0 0 .846V17.77a.85.85 0 0 0 .475.773l7.2 3.385c.01.005.024.003.035.008.094.04.2.065.3.065.1 0 .18-.02.266-.053.01-.004.02-.003.03-.007l7.686-3.253 6.892 3.24A.76.76 0 0 0 23.2 22c.152 0 .304-.047.436-.136a.86.86 0 0 0 .364-.71V4.23a.85.85 0 0 0-.475-.773z",
    fill: "#fff",
    mask: "url(#B)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.709347c1c994c4f8e22a7169eb6e9388.svg";
export { ForwardRef as ReactComponent };